import { render, staticRenderFns } from "./ScrollableTableCell.vue?vue&type=template&id=1c3b05cc&scoped=true&"
import script from "./ScrollableTableCell.vue?vue&type=script&lang=ts&"
export * from "./ScrollableTableCell.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollableTableCell.vue?vue&type=style&index=0&id=1c3b05cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3b05cc",
  null
  
)

export default component.exports